import { RangeType } from "./types";

export const cookingTimeRange: RangeType[] = [
  {
    id: "0-14",
    min: null,
    max: 14,
    title: "< 15 min",
  },
  {
    id: "15-45",
    min: 15,
    max: 45,
    title: "15-45 min",
  },
  {
    id: "45-P",
    min: 46,
    max: null,
    title: "45+ min",
  },
];
